<ng-container *transloco="let t; read: 'ime.common.contacts'">
  <app-toolbar>
    <app-breadcrumbs>
    </app-breadcrumbs>
    <app-page-search class="me-auto" [(searchString)]="searchString" (searchStringChange)="search$.next(searchString)"></app-page-search>
    <app-toolbar-list-buttons (addClick)="edit(null)">
    </app-toolbar-list-buttons>
  </app-toolbar>
  <p-table styleClass="p-datatable-sm p-datatable-striped"
           [value]="filteredData$ | async"
           dataKey="Id"
           [paginator]="true"
           [rows]="50"
           [rowsPerPageOptions]="rowsPerPageOptions"
           [(first)]="offset"
           [showCurrentPageReport]="true"
           currentPageReportTemplate="{first} to {last} of {totalRecords}">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="Code" class="text-wrap text-break">
          {{t('Code')}}
          <p-sortIcon field="Code"></p-sortIcon>
        </th>
        <th pSortableColumn="Name">
          {{t('Name')}}
          <p-sortIcon field="Name"></p-sortIcon>
        </th>
        <th pSortableColumn="Comment">
          {{t('Comment')}}
          <p-sortIcon field="Comment"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td>
          <button type="button" class="btn btn-link text-start" (click)="edit(row.Id)">{{row.Code}}</button>
        </td>
        <td>
          <button type="button" class="btn btn-link text-start" (click)="edit(row.Id)">{{row.Name}}</button>
        </td>
        <td>
          <button type="button" class="btn btn-link text-start" (click)="edit(row.Id)">{{row.Comment}}</button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</ng-container>
